import React, { useEffect, useState } from 'react';
import '.././App.css';
import Swal from 'sweetalert2';
import { auth, db } from '../firebase';
import {
  collection,
  query,
  orderBy,
  onSnapshot,
  getDoc,
  getDocs,
  doc
} from 'firebase/firestore';

export default function Storeledger() {
  const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer);
      toast.addEventListener('mouseleave', Swal.resumeTimer);
    }
  });

  const [searchText, setsearchText] = useState('');
  const [products, setproducts] = useState([]);

  // pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10); // Show 10 per page

  useEffect(() => {
    if (searchText === '') {
      fetchData1();
    } else {
      fetchData2();
    }
  }, [searchText]);

  const fetchData1 = async () => {
    try {
      const productsQuery = query(
        collection(db, 'products'),
        orderBy('product', 'asc')
      );
      onSnapshot(productsQuery, async (productsSnapshot) => {
        const products = productsSnapshot.docs.map((doc) => ({
          id: doc.id,
          data: doc.data(),
          departmentid: doc.data().departmentid
        }));

        // Collect all department IDs
        const departmentids = [
          ...new Set(products.map((detail) => detail.departmentid))
        ];

        // Fetch all departments
        const docRefs = departmentids.map((id) => doc(db, 'departments', id));
        const docSnaps = await Promise.all(
          docRefs.map((docRef) => getDoc(docRef))
        );

        const departmentMap = {};
        docSnaps.forEach((docSnap, index) => {
          if (docSnap.exists()) {
            departmentMap[departmentids[index]] = docSnap.data().department;
          }
        });

        // Fetch avakitems and javakitems
        const [avakSnapshot, javakSnapshot] = await Promise.all([
          getDocs(collection(db, 'avakitems')),
          getDocs(collection(db, 'javakitems'))
        ]);

        const avakQtyMap = {};
        const javakQtyMap = {};

        avakSnapshot.forEach((doc) => {
          const { productid, quantity } = doc.data();
          if (productid) {
            avakQtyMap[productid] =
              (avakQtyMap[productid] || 0) + (parseInt(quantity) || 0);
          }
        });

        javakSnapshot.forEach((doc) => {
          const { productid, quantity } = doc.data();
          if (productid) {
            javakQtyMap[productid] =
              (javakQtyMap[productid] || 0) + (parseInt(quantity) || 0);
          }
        });

        const combinedData = products.map((detail) => ({
          id: detail.id,
          data: detail.data,
          department: departmentMap[detail.departmentid] || '',
          avakqtytotal: avakQtyMap[detail.id] || 0,
          javakqtytotal: javakQtyMap[detail.id] || 0
        }));

        setproducts(combinedData);
        setCurrentPage(1); // Reset to first page when refetched
      });
    } catch (error) {
      Toast.fire({
        icon: 'error',
        title: error.message
      });
      console.error('FetchData1 Error:', error);
    }
  };

  const fetchData2 = async () => {
    try {
      const filteredData = products.filter((item) => {
        const prod = String(item.data.product).toUpperCase();
        return prod.includes(searchText.toUpperCase());
      });

      setproducts(filteredData);
      setCurrentPage(1);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  // Pagination calculations
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = products.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(products.length / itemsPerPage);

  return (
    <div>
      <div className="content-wrapper">
        <br />
        <section className="content">
          <div className="container-fluid">
            <button className="btn btn-secondary" style={{ float: 'right' }}>
              || Store Ledger ||
            </button>
            <br />
            <br />
            <br />
            <div className="card card-primary card-outline ex1">
              <div className="p-1">
                <input
                  type="search"
                  value={searchText}
                  onChange={(e) => setsearchText(e.target.value)}
                  className="form-control col-sm-4"
                  placeholder="Type here......"
                />
              </div>
              <div className="card-body table-responsive p-0">
                <table className="table table-bordered table-hover table-striped table-head-fixed">
                  <thead>
                    <tr>
                      <th>Sr No</th>
                      <th>Department</th>
                      <th>Product Name</th>
                      <th>Avak Qty</th>
                      <th>Javak Qty</th>
                      <th>Available Stock</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentItems.map((item, index) => {
                      const availableStock =
                        (item.avakqtytotal || 0) - (item.javakqtytotal || 0);

                      return (
                        <tr key={item.id}>
                          <td width="80">
                            {indexOfFirstItem + index + 1}
                          </td>
                          <td>{item.department}</td>
                          <td>{item.data.product}</td>
                          <td>{item.avakqtytotal}</td>
                          <td>{item.javakqtytotal}</td>
                          <td>{availableStock}</td>
                          <td>
                            <a
                              className="btn btn-sm bg-purple"
                              href={'view-store-ledger/' + item.id}
                            >
                              <i className="fa fa-eye"></i>
                            </a>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>

                {/* Pagination controls */}
                <div className="d-flex justify-content-between align-items-center p-2">
                  <button
                    className="btn btn-sm btn-primary"
                    disabled={currentPage === 1}
                    onClick={() => setCurrentPage((prev) => prev - 1)}
                  >
                    Previous
                  </button>
                  <span>
                    Page {currentPage} of {totalPages}
                  </span>
                  <button
                    className="btn btn-sm btn-primary"
                    disabled={currentPage === totalPages}
                    onClick={() => setCurrentPage((prev) => prev + 1)}
                  >
                    Next
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
